import { estimateDescription } from "../lib/estimate-description";

type Line = {
  description: string;
  catalogName?: string | null;
  catalogDescription?: string | null;
  itemName?: string | null;
  itemDescription?: string | null;
};

/** Keep invoice-specific notes; use catalog details only for name-only lines. */
export function InvoiceLineDescription({ line, catalog }: {
  line: Line;
  catalog?: { name: string; description?: string | null };
}) {
  const name = estimateDescription(line.catalogName ?? line.itemName ?? catalog?.name);
  const saved = estimateDescription(line.description);
  const details = saved && saved !== name
    ? saved
    : estimateDescription(line.catalogDescription ?? line.itemDescription ?? catalog?.description);
  return <div className="min-w-0 break-words">
    <p className="whitespace-pre-wrap font-medium text-[var(--ink)]">{name || saved || "Line item"}</p>
    {details && details !== (name || saved) && <p className="mt-1 whitespace-pre-wrap text-sm leading-6 text-[var(--ink-soft)]">{details}</p>}
  </div>;
}
